export const getTicketIdFromPathname = () => {
  const pathname = window.location.pathname;
  const match = pathname.match(/ticket\/(\d+)/);
  if (!match || match.length < 2) {
    return undefined;
  }
  return Number(match[1]);
};